
import { Vue } from "vue-class-component";

export default class WhiteTrash extends Vue {}
